import { Trans } from "@lingui/macro";
import { UiBox, UiIconBanktransfer, UiLink, UiTypography } from "@smp/ui";

import { useContextSupportMessenger } from "@/context/support_messenger";

import { useStyles } from "./manual.css";

export const Manual = () => {
  const {
    actions: { open },
  } = useContextSupportMessenger();

  const classes = useStyles();

  const handleClick = () => {
    open();
  };

  return (
    <UiBox display="flex" flexDirection="row">
      <UiBox>
        <UiTypography gutterBottom gutterBottomSize="md">
          <Trans>
            To pay using your current account, please send your company's full
            details (or ITN, if you have already signed a contract with
            SMMplanner) to the{" "}
            <UiLink onClick={handleClick}>support chat</UiLink>.
          </Trans>
        </UiTypography>
        <UiTypography>
          <Trans>
            A support technician will prepare the Agreement and the Invoice and
            send them to you for approval.
          </Trans>
        </UiTypography>
      </UiBox>
      <UiBox
        alignItems="center"
        display="flex"
        justifyContent="center"
        mb={2}
        ml={2}
        minWidth={250}
      >
        <UiIconBanktransfer className={classes.icon} />
      </UiBox>
    </UiBox>
  );
};
